import AuthLayoutSimple from '../../layout/AuthLayoutSimple';
import IdentificacaoForm from './IdentificacaoForm';
import './styles.css';
import { useState } from 'react';
import DetalhesSegundaVia from './Mensalidades/DetalhesSegundaVia';

const Acionar2ViaBoleto: React.FC = () => {
  const [mostrarTabela, setMostrarTabela] = useState<boolean>(false);
  const [contextData, setContextData] = useState<any>(null);

  const handleFormSubmitSuccess = (data: any) => {
    setContextData(data);
    setMostrarTabela(true);
  };

  const handleVoltar = () => {
    setMostrarTabela(false);
  };

  return (
    <AuthLayoutSimple>
      <div className='acionar-boleto-content width-100'>
        {!mostrarTabela ? (
          <IdentificacaoForm onSuccess={handleFormSubmitSuccess} />
        ) : (
          <DetalhesSegundaVia 
            onVoltar={handleVoltar} 
            mensalidades={contextData?.mensalidades || []}
            isPessoaFisica={contextData?.isPessoaFisica || false}
            codigoEmpresa={contextData?.codigoEmpresa}
          />
        )}
      </div>
    </AuthLayoutSimple>
  )
}

export default Acionar2ViaBoleto;
